module.exports = __webpack_public_path__ + "static/bg2-ce29a972cd0fff3d09f97bb0531a8ef1.jpg";